import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { hashHistory } from 'react-router';
import radio from 'radio';

import radioMessages from './radioMessages';
import SafeTradeAsBuyer from './buyer/safeTradeAsBuyer.jsx';
import SafeTradeAsSeller from './seller/safeTradeAsSeller.jsx';

function radioOpen(data = {}) {
    radio(radioMessages.OPEN).broadcast(data);
}

function radioClose() {
    radio(radioMessages.CLOSE).broadcast();
}

function scrollToTop() {
    window.scrollTo(0, 0);
}

function openFullScreen(data) {
    radioOpen(data);
    scrollToTop();
}

const allowedInitialBootRoutes = [
    '/samtale',
    '/status',
    '/betaling-avbrutt',
    '/betaling-ferdig',
];

class SafeTradeRoutes extends PureComponent {
    constructor() {
        super();
        this.booted = false;
        this.redirectToInitialRoute = this.redirectToInitialRoute.bind(this);
    }

    redirectToInitialRoute({ location: { pathname } }, replacePath) {
        if (!this.booted) {
            this.booted = true;

            if (pathname === '/' || pathname === '/start-trygg-betaling') {
                replacePath('/samtale');
            } else if (!allowedInitialBootRoutes.includes(pathname)) {
                replacePath('/status');
            }
        }
    }

    render() {
        const { role } = this.props;
        const SafeTradeAsRole =
            role === 'BUYER' ? SafeTradeAsBuyer : SafeTradeAsSeller;

        return (
            <SafeTradeAsRole
                history={hashHistory}
                onEnter={this.redirectToInitialRoute}
                onOpenFullScreen={openFullScreen}
                onCloseFullScreen={radioClose}
            />
        );
    }
}

SafeTradeRoutes.propTypes = {
    role: PropTypes.oneOf(['BUYER', 'SELLER']).isRequired,
};

export default SafeTradeRoutes;



// WEBPACK FOOTER //
// ./safeTrade/safeTradeApp.jsx